export default __webpack_public_path__ + "static/media/full_image.7448cce9.jpg";